const clientUserRoles = [
    "Member",
    "CompanyAdmin",
    "SystemAdmin"
];

export default clientUserRoles;